export const educations = [
  {
    id: 1,
    duration: "Feb. 2023 - Oct. 2023",
    title: "CFA Level I",
    institution: "CFA Institute",
    grade: "Scored above the global top 10% among 10,000+ candidates."
  },
  {
    id: 2,
    duration: "Aug. 2018 - Dec. 2022",
    title: "Bachelor's Degree in Finance",
    institution: "Tecnologico de Monterrey",
    grade: "GPA: 3.7/4.0",
  },
  {
    id: 3,
    duration: "Aug. 2021 - Dec. 2021",
    title: "International Excellence Program",
    institution: "University of California, Berkeley",
    grade: "GPA: 3.7/4.0",
  },
];
